import type { enKaohsiung } from './en.kaohsiung';

/** Kaohsiung en català. Les frases de pràctica d’anglès es mantenen en anglès. */
export const caKaohsiung: typeof enKaohsiung = {
  kaohsiung: {
    mapNames: { kaohsiung: 'Kaohsiung' },
    zones: {
      kh_zuoying: 'Estació d’alta velocitat de Zuoying',
      kh_lotus: 'Estany del Lotus',
      kh_yancheng: 'Barri antic de Yancheng',
      kh_loveRiver: 'Riu de l’Amor',
      kh_formosa: 'Bulevard Formosa',
      kh_liuhe: 'Mercat nocturn de Liuhe',
      kh_pier2: 'Centre d’art Pier-2',
      kh_harbor: 'Port de Kaohsiung',
    },
    objects: {
      kh_hsr: 'Estació d’alta velocitat · Zuoying',
      kh_mrtZuoying: 'KMRT · Zuoying (R16)',
      kh_mrtFormosa: 'KMRT · Bulevard Formosa',
      kh_mrtYancheng: 'KMRT · Yanchengpu (O2)',
      kh_lotusView: 'Mirador de l’Estany del Lotus',
      kh_dragon: 'Pagodes del Drac i el Tigre',
      kh_dome: 'Cúpula de Llum',
      kh_papaya: 'Parada de batut de papaia',
      kh_oyster: 'Parada de truita d’ostres',
      kh_squid: 'Parada de calamar a la brasa',
      kh_loveBoat: 'Taquilla del Vaixell de l’Amor',
      kh_pier2: 'Magatzem de Pier-2',
      kh_giants: 'Estàtues gegants',
      kh_lrt: 'Parada del tramvia · Pier-2',
      kh_lrtHamasen: 'Parada del tramvia · Hamasen',
      kh_ferry: 'Ferri a Cijin',
      kh_icecream: 'Carretó de gelats de Cijin',
      kh_tower85: 'Mirador de la Torre 85',
    },
    npc: {
      kh_stationStaff: 'Personal de l’estació',
      kh_monk: 'Monjo',
      kh_domeGuide: 'Guia de la Cúpula',
      kh_papayaVendor: 'Venedor de batut de papaia',
      kh_oysterAuntie: 'Tieta de les truites d’ostres',
      kh_boatman: 'Capità del Vaixell de l’Amor',
      kh_cyclist: 'Ciclista',
      kh_artist: 'Artista de Pier-2',
      kh_fisher: 'Pescador de Cijin',
      kh_surfer: 'Surfista',
      kh_kiteKid: 'Nen de l’estel',
      kh_kiteGirl: 'Nena de l’estel',
    },
    items: {},

    closed: 'La parada és tancada. El mercat nocturn de Liuhe es desperta a les cinc de la tarda!',
    kmrt: {
      name: 'KMRT',
      ask: 'Which exit is this, please?',
      text: 'El metro de Kaohsiung (高雄捷運): la línia vermella va de nord a sud i la taronja d’est a oest. Es creuen a Bulevard Formosa.',
      to: { zuoying: '🔴 Zuoying — estació d’alta velocitat i Estany del Lotus', formosa: '🔴🟠 Bulevard Formosa — Cúpula de Llum i Liuhe', yancheng: '🟠 Yanchengpu — Riu de l’Amor i Pier-2' },
      riding: 'Compte amb el forat! El tren llisca sota la ciutat…',
    },
    lrt: {
      text: 'El tramvia circular de Kaohsiung (高雄輕軌) va ser el primer tren lleuger de Taiwan (2015). No té cables aeris: els tramvies es carreguen a cada parada en vint segons!',
      to: { pier2: '🚈 Anar a Pier-2 (C12)', hamasen: '🚈 Anar a Hamasen i el ferri (C14)' },
      ask: '❓ Per què no hi ha cables?',
      riding: 'Ding ding! El tramvia verd brunzeix sobre la via de gespa.',
      q: 'Why does this tram have no overhead wires?',
      a: ['It charges its batteries at every stop.', 'It is pulled by horses.', 'It runs on wind power.'],
      right: 'Exacte! Els supercondensadors es carreguen en segons mentre la gent puja i baixa.',
      wrong: 'Mira el sostre quan s’atura: un bracet s’aixeca per carregar…',
    },
    dome: {
      text: 'La Cúpula de Llum (光之穹頂) és sota els teus peus, a l’estació de Bulevard Formosa: 30 metres de diàmetre, 4.500 peces de vidre de colors, l’obra de vidre més gran del món. Explica una història d’aigua, terra, llum i foc.',
      ask: '🌈 Aprèn una dada (anglès)',
      q: 'What is the Dome of Light made of?',
      a: ['Coloured glass — four thousand five hundred pieces.', 'Plastic bottles.', 'Paper lanterns.'],
      right: 'Sí! L’artista italià Narcissus Quagliata hi va treballar quatre anys.',
      wrong: 'Mira els colors que brillen a través de les closques de vidre sobre l’escala…',
    },
    dragon: {
      text: 'Les Pagodes del Drac i el Tigre (龍虎塔) s’alcen sobre l’Estany del Lotus. S’ENTRA per la boca del drac i se SURT per la boca del tigre: així la mala sort es torna bona!',
      ask: '🐉 Per on s’entra? (anglès)',
      q: 'Which mouth do you walk in through?',
      a: ['In through the dragon, out through the tiger.', 'In through the tiger, out through the dragon.', 'It doesn’t matter.'],
      right: 'Exacte! Drac en entrar, tigre en sortir: ara tens bona sort la resta del dia.',
      wrong: 'Compte! A l’inrevés porta mala sort. Primer el drac…',
    },
    lotus: {
      text: 'L’Estany del Lotus (蓮池潭) és un llac de 42 hectàrees envoltat de temples. A l’estiu es torna rosa de flors de lotus. A l’altra banda de l’aigua, l’estàtua de Xuantian Shangdi fa 72 metres: l’estàtua d’un déu dreta sobre l’aigua més alta del món.',
      look: '🔭 Mira pel telescopi',
      looked: 'Drac i tigre, dos pavellons i un déu gegant amb espasa dret sobre l’aigua. Passa volant un martinet.',
      phrase: 'Look! A giant statue on the water!',
    },
    food: {
      papaya: { vendor: 'Papaya milk, fresh and cold! Large or small?', ok: 'A large papaya milk, please.', bad: ['Papaya. Milk. Now.', 'Give me the orange one.'], done: 'Dolç, cremós i gelat: Kaohsiung en un vas. El venedor pica l’ullet: “El millor de Liuhe!”', price: 30 },
      oyster: { vendor: 'Oyster omelette! Hot off the griddle. With sweet sauce?', ok: 'Yes, please. One oyster omelette with sauce.', bad: ['Omelette! Fast!', 'Oysters. Mine.'], done: 'Vores cruixents, centre tendre, ostres grosses i salsa dolça i picant. Deliciós!', price: 35 },
      squid: { vendor: 'Grilled squid! Spicy or not spicy?', ok: 'Not spicy, please. One grilled squid.', bad: ['Squid. Give.', 'I want the whole sea.'], done: 'Fumat, tendre, pintat amb soja i sèsam. Te’l menges del pal com tothom.', price: 40 },
      icecream: { vendor: 'Cijin ice cream! Mango, peanut or taro?', ok: 'One mango ice cream, please.', bad: ['Ice. Cream. Mango.', 'I want all of them for free.'], done: 'Fred i fruiter, amb brisa marina i una gavina mirant-te el cucurutxo. Perfecte!', price: 25 },
    },
    boat: {
      text: 'El Vaixell de l’Amor (愛之船) navega pel Riu de l’Amor sota els ponts. De nit les ribes s’il·luminen de rosa, violeta i blau.',
      buy: '🎫 Compra un bitllet (anglès)',
      q: 'How do you ask for a ticket politely?',
      a: ['Two tickets for the Love Boat, please.', 'Boat. Ticket. Now.', 'Take me somewhere.'],
      right: 'Llisques sota els ponts. Les palmeres es gronxen, els cors brillen als fanals i el capità saluda tots els vaixells.',
      wrong: 'El capità somriu: “Could you say that more politely?”',
      price: 40,
      poor: 'No tens prou monedes per al vaixell.',
    },
    pier2: {
      text: 'Centre d’art Pier-2 (駁二藝術特區): aquests magatzems de maó guardaven sucre i farina de peix per al port als anys 70. Després d’anys abandonats, el 2006 es van convertir en tallers, galeries i una plaça per patinar.',
      ask: '🎨 Aprèn una dada (anglès)',
      q: 'What were these buildings before they were an art centre?',
      a: ['Port warehouses for sugar and fish meal.', 'A train station.', 'A school.'],
      right: 'Exacte! Ara les vies velles travessen la plaça i els murs són plens de murals.',
      wrong: 'Mira les portes grans i les vies a terra…',
    },
    giants: {
      text: 'Les estàtues gegants de Pier-2: un treballador del moll i una pescadora, lluents i quadrats, que recorden la gent que va construir el port.',
      pose: '💪 Posa com un gegant',
      posed: 'Braços amunt, barbeta alta! Els turistes riuen i et fan fotos al costat dels gegants.',
      phrase: 'The worker is strong. The fisherwoman is brave.',
    },
    ferry: {
      text: 'El ferri Gushan–Cijin (鼓山渡輪) travessa el port fins a l’illa de Cijin, amb el seu far, la platja de sorra negra i el carrer del marisc. Les motos també pugen a bord!',
      ask: '⛴️ Aprèn una dada (anglès)',
      q: 'How long does the ferry to Cijin take?',
      a: ['About five minutes.', 'Two hours.', 'All day.'],
      right: 'Sí! Cinc minuts de travessia… i les motos entren primer.',
      wrong: 'Mira a l’altra banda del port: des d’aquí es veu Cijin…',
    },
    tower: {
      text: 'La Torre 85 (高雄85大樓) fa 347 metres: dues potes i una torre central, amb la forma del caràcter 高 (gāo, “alt”), el primer caràcter de Kaohsiung. Va ser l’edifici més alt de Taiwan fins al Taipei 101.',
      ask: '🏙️ Aprèn una dada (anglès)',
      q: 'Which Chinese character is the tower shaped like?',
      a: ['高 — “tall”, the first character of Kaohsiung.', '大 — “big”.', '山 — “mountain”.'],
      right: 'Exacte! Dues potes i un centre alt, igual que 高.',
      wrong: 'Mira la seva forma: dues potes que aguanten una torre alta…',
    },

    talk: {
      kh_stationStaff: {
        intro: 'Benvingut a Kaohsiung! Aquí fa sol tot l’any. T’ajudo a trobar alguna cosa?',
        q: 'How do you ask where the MRT is?',
        a: ['Excuse me, where is the MRT station?', 'MRT. Where.', 'Take me to the MRT!'],
        right: 'Molt educat! L’entrada del KMRT és a la plaça, a la teva dreta.',
        wrong: 'Prova de començar amb “Excuse me…”',
      },
      kh_domeGuide: {
        intro: 'Benvingut a Bulevard Formosa! Baixant l’escala hi ha la Cúpula de Llum. Endevines per a què serveix?',
        q: 'Which of these happens under the Dome of Light?',
        a: ['Weddings — couples get married under the glass!', 'Swimming races.', 'Football matches.'],
        right: 'Sí! Cada any hi ha parelles que trien aquesta estació per a les fotos de casament.',
        wrong: 'Pensa en alguna cosa romàntica, amb colors i llum…',
      },
      kh_monk: [
        'Entra pel drac i surt pel tigre. A poc a poc: a l’Estany del Lotus no hi ha pressa.',
        'English practice: “Good morning.” — “Good morning. Peace be with you.”',
        'El lotus neix del fang i s’obre net al sol. Per això l’estimem.',
      ],
      kh_papayaVendor: [
        'Les papaies de Kaohsiung són les més dolces: el sol fa tota la feina!',
        'English practice: “Would you like ice in it?” — “Yes, please. Lots of ice!”',
        'La meva àvia va obrir aquesta parada. Mateixa recepta, mateix soroll de batedora!',
      ],
      kh_oysterAuntie: [
        'Ostres fresques de la llacuna cada matí. Cruixent per fora, tendre per dins!',
        'English practice: “Is it spicy?” — “Just a little.”',
        'Regla del mercat nocturn: menja, passeja, i torna a menjar!',
      ],
      kh_boatman: [
        'English practice: “All aboard!” — això dic quan el vaixell és a punt.',
        'El Riu de l’Amor era brut. Ara la gent rema, corre i canta karaoke a les seves ribes!',
        'Trenta minuts riu avall i tornada. Els ponts més baixos són a prop del port.',
      ],
      kh_cyclist: [
        'English practice: “Passing on your left!”',
        'Es pot anar en bici des del Riu de l’Amor fins al port i Pier-2: tot pla.',
        'Les palmeres del riu? S’inclinen perquè el vent del mar bufa cada tarda.',
      ],
      kh_artist: [
        'Pinto balenes. Kaohsiung és una ciutat portuària: aquí el mar és a tot arreu.',
        'English practice: “What are you painting?” — “A whale, and a tram, and the sun.”',
        'Les vies velles de la plaça portaven sucre als vaixells. Ara hi passen monopatins per sobre.',
      ],
      kh_fisher: [
        'Visc a Cijin. Cinc minuts en ferri, però sembla una altra illa.',
        'English practice: “Did you catch anything?” — “A big one! It got away.”',
        'Quan entren els vaixells grans, l’aigua puja. Agafa’t el barret!',
      ],
      kh_surfer: [
        'A Cijin hi ha onades a l’hivern i una platja de sorra negra. Les millors postes de sol de Taiwan!',
        'English practice: “Can you swim?” — “Yes, I can. Can you surf?”',
        'El ferri porta la meva taula gratis. Les motos paguen una mica més.',
      ],
      kh_kiteKid: [
        'El meu estel és el del drac! Té dotze cues.',
        'English practice: “Hold the string tight!” — “I’ve got it!”',
      ],
      kh_kiteGirl: [
        'El vent del mar és perfecte a la tarda. Espera… ara!',
        'English practice: “Look how high it is!” — “Higher than the 85 tower!”',
      ],
    },
  },
};
